import React from 'react';

export default function MissionSection() {
  const activities = [
    {
      icon: 'ri-smartphone-line',
      title: 'Screening',
      subtitle: 'OxyAI™',
      description: 'AI-powered oxygen risk screening through OxyAI™',
      image: 'https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/5ca3631e0372845605a7c52b30318db2.png'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Education',
      subtitle: 'Books, Media & Community',
      description: 'Books, media, and community programs that build oxygen literacy',
      image: 'https://public.readdy.ai/ai/img_res/3d15cef82be13f8b9314a50585d77256.jpg'
    },
    {
      icon: 'ri-capsule-line',
      title: 'Supplementation Access',
      subtitle: 'Capsules, Sprays & OxyKits',
      description: 'Capsules, sprays, and OxyKits delivered through community and healthcare networks',
      image: 'https://readdy.ai/api/search-image?query=Medical%20oxygen%20supplements%20including%20capsules%20and%20spray%20bottles%2C%20clean%20pharmaceutical%20packaging%20with%20teal%20accents%2C%20OxyKit%20family%20healthcare%20package%2C%20professional%20medical%20products%20display%2C%20oxygen%20therapy%20supplements%20arranged%20neatly%20on%20white%20background&width=400&height=300&seq=supplements-kit&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            What We Do
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            We work across three core areas:
          </p>
        </div>

        {/* Activities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {activities.map((activity, index) => (
            <div 
              key={index} 
              className="group bg-[#FAFAFA] rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="aspect-video overflow-hidden">
                <img 
                  src={activity.image} 
                  alt={activity.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              {/* Content */}
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#12B6B6]/10">
                    <i className={`${activity.icon} text-2xl text-[#12B6B6]`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#111111]">{activity.title}</h3>
                    <p className="text-sm text-[#12B6B6] font-medium">{activity.subtitle}</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">{activity.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
